import { render, staticRenderFns } from "./AiSearch.vue?vue&type=template&id=8de38d4a"
import script from "./AiSearch.vue?vue&type=script&lang=ts"
export * from "./AiSearch.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports